var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-avsnewsletter header-margin"},[_c('h2',[_vm._v("APOVERLAG-Newsletter Archiv")]),_vm._v(" "),_c('iframe',{staticClass:"avs-newsletter-iframe",attrs:{"id":"avs-newsletter-iframe","src":_vm.iframe.src},on:{"load":_vm.load}})])
}
var staticRenderFns = []

export { render, staticRenderFns }